import type React from "react"
import styled from "styled-components"

interface PropertyButtonProps {
  action: () => void
  selected?: boolean
  children: React.ReactNode
}

const StyledButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 160px;
  height: 160px;
  background-color: white;
  border: 1px solid #4caf8a;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  color: #555;
  font-size: 14px;
  font-weight: 500;
  &:hover {
    background-color: #e7f7ee;
    color: #4caf8a;
  }
`

export function SquareButton({ action, children }: PropertyButtonProps) {
  return (
    <StyledButton onClick={action}>
      {children}
    </StyledButton>
  )
}

